import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=7715d014&scoped=true&"
import script from "./DocumentLink.vue?vue&type=script&lang=ts&"
export * from "./DocumentLink.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentLink.vue?vue&type=style&index=0&id=7715d014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7715d014",
  null
  
)

export default component.exports